/**
 * Because there is no way to launch a mail app on the web without first opening a new
 * message view, the `OpenEmailButton` component is only available on native platforms.
 */
export const OpenEmailButton = () => null;
